module.exports = __webpack_public_path__ + "images/Editas_Medicine-1a7873.png";